import React from 'react';
import PropTypes from 'prop-types';
import scriptjs from 'scriptjs';

export default class FilepickerInput extends React.Component {
  constructor () {
    super();
    this.state = {
      isFilepickerLoaded: false,
    };
  }
  componentDidMount() {
    /*
    * Load filepicker.js only if its required
    */
    scriptjs(['//api.filestackapi.com/filestack.js'], 'filepickerBundle');
    scriptjs.ready('filepickerBundle', () => {
      const filepickerKey = 'AjjW6AZScWrkwAWscd6hQz';
      window.filepicker.setKey(filepickerKey);
      this.setState({
        isFilepickerLoaded: true,
      });
    });
  }

  render() {
    return (
      this.state.isFilepickerLoaded
      ?
      <a onClick={this.pickAndStore.bind(this)} className={`btn ${this.props.className}`}>
        {this.props.children}
      </a>
      :
      <a className={`btn ${this.props.className}`}>Loading...</a>
    );
  }

  pickAndStore () {
    let mimetype = this.props.mimetype || '*/*';
    window.filepicker.pickAndStore(
      {
        mimetype: mimetype,
        services: ['COMPUTER', 'URL', 'DROPBOX', 'FACEBOOK', 'GMAIL', 'GOOGLE_DRIVE', 'SKYDRIVE'],
      }, {}, this.handleSuccess.bind(this)
    );
  }

  handleSuccess (blob) {
    this.props.onChange(blob);
  }
}

FilepickerInput.defaultProps = {
  className: '',
};

FilepickerInput.propTypes = {
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/common/views/form/FilepickerInput.js